import { useMemo } from "react";
import {
	BooleanInput,
	Datagrid,
	DeleteButton,
	EditButton,
	Filter,
	List,
	ShowButton,
	BooleanField,
	TextField,
	TextInput,
	usePermissions,
} from "react-admin";

import { CustomDeleteButtonWithConfirmation } from "../../customComponents/CustomButtons";
import { userPreferences } from "../../utils/fakeUserPrefrences";
import { constants, rolesGlobal } from "../../utils/constants";
import { useTranslate } from "ra-core";
import { CustomBooleanInput } from "../../customComponents/CustomBooleanInput";

const CategoryFilter = (props) => (
	<Filter {...props}>
		<TextInput source="search" alwaysOn />
		<BooleanInput source="isActive" />
		<BooleanInput source="comingSoon" />
	</Filter>
);

const CustomBooleanField = ({ record }) => {
	return record.comingSoon == true ? (
		<BooleanField source="comingSoon" label="Coming Soon" />
	) : (
		<></>
	);
};

const Delete = (props) => {
	const {
		record: { isDeletable, isLinked },
	} = props;
	const translate = useTranslate();
	if (!isDeletable) return <></>;
	if (isLinked)
		return (
			<CustomDeleteButtonWithConfirmation
				confirmTitle={translate("objectives.delete.confirmTitle")}
				confirmContent={translate("objectives.delete.confirmContent")}
				{...props}
			/>
		);
	return <DeleteButton {...props} />;
};

const ReadOnlyOrToggleField = ({ source, disabled, record, ...rest }) => {
    const inputValue = record ? record[source] : false;

    if (disabled) {
        return (
            <span style={{
                padding: '4px 8px',
                borderRadius: 4,
                fontSize: '0.85rem',
                fontWeight: 'bold',
                backgroundColor: inputValue ? '#e8f5e9' : '#ffebee',
                color: inputValue ? '#2e7d32' : '#c62828',
                display: 'inline-block'
            }}>
                {inputValue ? "Active" : "Inactive"}
            </span>
        );
    }

    return <CustomBooleanInput source={source} record={record} disabled={false} {...rest} />;
};

export const ObjectiveList = (props) => {
	const { permissions, isLoading } = usePermissions();
	const defaultLocale = useMemo(
		() => userPreferences.defaultTranslationLanguage,
		[]
	);

    if (isLoading) return null;
    const userRoles = Array.isArray(permissions) ? permissions : (permissions ? [permissions] : []);
    const isCoach = userRoles.includes(rolesGlobal.coach);
    const hideActions = isCoach || userRoles.length === 0;

	return (
		<List
			{...props}
			perPage={constants.perPage}
			bulkActionButtons={false}
			filters={<CategoryFilter />}
		>
			<Datagrid>
				<TextField source="displayIndex" />
				<TextField
					source={`titles.${userPreferences.defaultTranslationLanguage}`}
					sortable={false}
				/>
				<TextField
					source={`recommendationTitles.${userPreferences.defaultTranslationLanguage}`}
					sortable={false}
				/>
				<TextField
					source={`contentType.titles.${defaultLocale}`}
					sortable={false}
				/>
				<CustomBooleanField label="Coming Soon" />
				<ReadOnlyOrToggleField source="isActive" sortable={false} disabled={hideActions} />
				<ShowButton />
				{hideActions === false && <EditButton />}
				{hideActions === false && <Delete />}
			</Datagrid>
		</List>
	);
};
